export const API_KEY = '7361ee272fb6f5a3d88323ba1e92f4ed'
export const BASE_URL = 'https://api.openweathermap.org/data/2.5/weather'